import Phaser from 'phaser';
import * as fontConfig from '../scripts/FontConfig.js';

export default class SelectGroupScene extends Phaser.Scene {
  constructor() {
    super('SelectGroupScene');
  }

  create() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    // Background image
    this.add.image(width / 2, height / 2, 'backgroundScreen').setOrigin(0.5);
    
    // Add fade-in transition
    this.cameras.main.fadeIn(300, 0, 0, 0);
    
    // Title text at the top
    const titleText = fontConfig.createText(
      this,
      width / 2, 
      height / 2 - 120, 
      'In welke groep zit je?', 
      'title', {
        fill: '#ffffff',
        align: 'center'
      }
    ).setOrigin(0.5);
    
    // Create group selection buttons
    this.createGroupButtons();
  }
  
  createGroupButtons() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    // Button dimensions and spacing
    const buttonWidth = 200;
    const buttonHeight = 80;
    const buttonSpacing = 60;
    const centerY = height / 2 + 20;
    
    // Group 5-6 Button (Group 1)
    const group1ButtonX = width / 2 - buttonWidth / 2 - buttonSpacing / 2;
    const group1ButtonBg = this.add.rectangle(group1ButtonX, centerY, buttonWidth, buttonHeight, 0x3498db, 0.9);
    group1ButtonBg.setStrokeStyle(3, 0x2980b9);
    
    const group1ButtonText = fontConfig.createText(
      this,
      group1ButtonX, 
      centerY, 
      'Groep 5 - 6', 
      'default', {
        fill: '#ffffff',
        align: 'center'
      }
    ).setOrigin(0.5);
    
    // Group 7-8 Button (Group 2)
    const group2ButtonX = width / 2 + buttonWidth / 2 + buttonSpacing / 2;
    const group2ButtonBg = this.add.rectangle(group2ButtonX, centerY, buttonWidth, buttonHeight, 0x3498db, 0.9);
    group2ButtonBg.setStrokeStyle(3, 0x2980b9);
    
    const group2ButtonText = fontConfig.createText(
      this,
      group2ButtonX, 
      centerY, 
      'Groep 7 - 8', 
      'default', {
        fill: '#ffffff',
        align: 'center'
      }
    ).setOrigin(0.5);
    
    // Make buttons interactive
    this.setupButtonInteractions(group1ButtonBg, group1ButtonText, 1, 0x3498db, 0x5dade2, 0x2980b9, 0x3498db);
    this.setupButtonInteractions(group2ButtonBg, group2ButtonText, 2, 0x3498db, 0x5dade2, 0x2980b9, 0x3498db);
  }
  
  setupButtonInteractions(buttonBg, buttonText, groupNumber, defaultColor, hoverColor, defaultStroke, hoverStroke) {
    // Make both background and text interactive
    buttonBg.setInteractive({ useHandCursor: true });
    buttonText.setInteractive({ useHandCursor: true });
    
    const onHover = () => {
      buttonBg.setFillStyle(hoverColor, 0.95);
      buttonBg.setStrokeStyle(3, hoverStroke);
    };
    
    const onOut = () => {
      buttonBg.setFillStyle(defaultColor, 0.9);
      buttonBg.setStrokeStyle(3, defaultStroke);
    };
    
    const onClick = () => {
      this.selectGroup(groupNumber);
    };
    
    // Add interactions to both background and text
    buttonBg.on('pointerover', onHover);
    buttonBg.on('pointerout', onOut);
    buttonBg.on('pointerdown', onClick);
    buttonText.on('pointerover', onHover);
    buttonText.on('pointerout', onOut);
    buttonText.on('pointerdown', onClick);
  }
  
  async selectGroup(groupNumber) {
    console.log(`Selected group: ${groupNumber}`);
    
    // Store the group selection immediately for game flow
    if (window.sessionManager) {
      // Set group immediately (non-blocking)
      window.sessionManager.setGroup(groupNumber);
      
      // Initialize session in the background (non-blocking)
      window.sessionManager.initializeSessionWithGroup(groupNumber)
        .then(() => {
          console.log(`✅ Session initialized with group ${groupNumber} (background)`);
        })
        .catch((error) => {
          console.error('❌ Error initializing session with group (background):', error);
          console.log('ℹ️ Game will continue with local group storage only');
        });
    } else {
      console.warn('⚠️ SessionManager not available, storing group locally as fallback');
      localStorage.setItem('hypnobreaker_group', groupNumber.toString());
    }
    
    // Also store globally for immediate access
    window.hypnoBreakerGroup = groupNumber;
    
    console.log('🚀 Proceeding to StartScene while session initializes in background...');
    
    // Transition to StartScene immediately with fade effect
    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.cameras.main.once('camerafadeoutcomplete', () => {
      this.scene.start('StartScene');
    });
  }
}